<div [style.color]="valueColor" class="value">
  {{ values | formatNumberComma: valueLabel }}
</div>
<div [style.color]="labelColor" class="label">{{ label }}</div>
